import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Layout/Navbar';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import Login from './pages/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import QualifiedLeads from './pages/QualifiedLeads';

const AppRoutes: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <Dashboard />
              </>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/clients" 
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <Dashboard />
              </>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/leads" 
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <Leads />
              </>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/qualified" 
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <QualifiedLeads />
              </>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
};

export default AppRoutes; 